export const shadows = {
    xs: '0px 1px 2px 0px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(0, 0, 0, 0.08)',
    sm: '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.08)',
    md: '0px 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 8px 16px rgba(0, 0, 0, 0.08)',
    lg: '0px 12px 16px -4px rgba(0, 0, 0, 0.12), 0px 4px 6px rgba(0, 0, 0, 0.08)',
    xl: '0px 20px 24px -4px rgba(0, 0, 0, 0.12), 0px 8px 8px rgba(0, 0, 0, 0.08)',
    '2xl': '0px 24px 48px -12px rgba(0, 0, 0, 0.18)',
    '3xl': '0px 32px 64px -12px rgba(0, 0, 0, 0.14)'
} as const
